import { useTranslation } from 'react-i18next';

const LOCALE_LABEL_KEYS = {
    en: 'language.english',
    es: 'language.spanish',
};

function LanguageSwitcher({ className = '' }) {
    const { i18n, t } = useTranslation('common');
    const current = i18n.language?.startsWith('es') ? 'es' : 'en';
    const otherLocale = current === 'en' ? 'es' : 'en';
    const label = t(LOCALE_LABEL_KEYS[otherLocale]);
    const colorClass =
        otherLocale === 'es'
            ? 'text-red-700 hover:text-red-900'
            : 'text-blue-700 hover:text-blue-900';

    const setLocale = () => {
        i18n.changeLanguage(otherLocale);
    };

    return (
        <button
            type="button"
            onClick={setLocale}
            className={`px-2 py-1 text-sm transition-colors rounded ${colorClass} ${className}`}
            style={{ fontFamily: 'Montserrat, sans-serif' }}
            aria-label={`${t('language.label')}: ${label}`}
        >
            {label}
        </button>
    );
}

export default LanguageSwitcher;
